module.exports = __webpack_public_path__ + "static/media/web design.ef7b8e49.svg";